import { useAuthStore } from '~/stores/auth'
import { navigateTo } from '#imports'

export default defineNuxtRouteMiddleware(async (to, from) => {
    // Skip middleware on server-side to let client-side Firebase handle auth sync
    if (process.server) return

    const authStore = useAuthStore()

    // IF accessing a protected route, WAIT for Firebase to finish initial sync
    if (to.path.startsWith('/admin') || to.path.startsWith('/user') || to.path.startsWith('/checkout')) {
        await authStore.waitForAuth()
    }

    // Routes that require admin role
    if (to.path.startsWith('/admin')) {
        if (!authStore.isAuthenticated || !authStore.isAdmin) {
            console.warn('Access denied to admin route. Redirecting...')
            return navigateTo('/auth/login')
        }
    }

    // Routes that require authentication (User Profile, Orders, Checkout)
    const protectedUserRoutes = ['/user', '/checkout', '/cart']
    if (protectedUserRoutes.some(path => to.path.startsWith(path)) && !authStore.isAuthenticated) {
        return navigateTo('/auth/login')
    }

    // Redirect authenticated users away from auth pages
    if (to.path.startsWith('/auth/')) {
        if (authStore.isAuthenticated) {
            return authStore.isAdmin ? navigateTo('/admin') : navigateTo('/')
        }
    }
})
